<template>
  <v-main v-show="show">
    <v-layout row justify-center>
      <v-dialog
        v-model="loading"
        persistent
        fullscreen
        content
        content-class="centered-dialog"
      >
        <v-container fill-height>
          <v-layout column justify-center align-center>
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="blue"
            ></v-progress-circular>
            <h1 v-if="message != null">{{ message }}</h1>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>

    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-spacer />
          <v-container fill-height>
            <v-layout align-center row wrap>
              <v-flex md6 offset-md3 class="userform">
                <div class="text-md-center">
                  <div>
                    <v-icon :size="220">fab fa-bitcoin </v-icon>
                  </div>
                </div>
                <div class="text-md-center">
                  <h1>Welcome to NixieClock.biz Admin</h1>
                  <p>
                    Please log in to continue:
                  </p>
                  <v-form ref="usernameForm" @submit="submit">
                    <v-text-field
                      :rules="usernameRules"
                      v-model="usernameInput"
                      label="Username"
                      placeholder="John Doe"
                      required
                    />

                    <v-text-field
                      :rules="usernameRules"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      v-model="passwordInput"
                      :type="show1 ? 'text' : 'password'"
                      label="Password"
                      @click:append="show1 = !show1"
                      placeholder="SuperSecretPassword"
                      required
                    />

                    <v-btn type="submit" color="primary">Let's go </v-btn>
                  </v-form>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import cartApi from "../modules/cart-api";
import { store } from "../store.js";

export default {
  name: "UsernameDialog",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    username: {
      type: String,
      default: ""
    },
    token: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      usernameInput: this.username,
      usernameSet: false,
      passwordInput: "",
      environment: process.env.VUE_APP_BITCOIND_ENVIRONMENT || "UNKNOWN",

      usernameRules: [
        v => !!v || "User name must not be empty",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      passwordRules: [
        v => !!v || "Password name must not be empty",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      storeState: store.state,
      loading: false,
      message: 'Logging in',
      show1: false,
    };
  },

  methods: {
    async submit(e) {
      this.loading = true;
      e.preventDefault();
      if (this.$refs.usernameForm.validate()) {
        let res = await cartApi.tryLogin(this.usernameInput, this.passwordInput);
          this.$log.debug("Token is: " + res.data.id);
          if (res.status === 200) {
            store.setLoginInfo(res.data.id, this.usernameInput);
            this.loading = false;
            window.location.reload();
          } else {
            this.$log.error('Login failed: ' + res.status);
            store.resetLoginInfo();
            this.loading = false;
          }
      }
    }
  },
  computed: {
    getEnv() {
      return process.environment;
    }
  }
};
</script>

<style scoped>
.userform h1 {
  margin-top: 30px;
}

.userform p {
  margin: 20px 0;
}
</style>
